import React from 'react';
import PropTypes from 'prop-types';

import {FacebookShareButton, LinkedinShareButton, TwitterShareButton,} from 'react-share';

// import './Share.scss';

const Share = ({socialConfig}) => (
    <ul className="d-inline list-unstyled list-inline list-social">
        <li className="list-inline-item list-social-item mr-3">
            <FacebookShareButton url={socialConfig.config.url} className="button is-outlined is-rounded facebook">
                <i className="fe fe-facebook"></i>
            </FacebookShareButton>
        </li>
        <li className="list-inline-item list-social-item mr-3">
            <TwitterShareButton url={socialConfig.config.url} className="button is-outlined is-rounded twitter"
                                title={socialConfig.config.title} via={socialConfig.twitterHandle.split('@').join('')}>
                <i className="fe fe-twitter"></i>
            </TwitterShareButton>
        </li>
        <li className="list-inline-item list-social-item mr-3">
            <LinkedinShareButton url={socialConfig.config.url} className="button is-outlined is-rounded linkedin"
                                 title={socialConfig.config.title}>
                <i className="fe fe-linkedin"></i>
            </LinkedinShareButton>
        </li>
    </ul>
);

Share.propTypes = {
    socialConfig: PropTypes.shape({
        twitterHandle: PropTypes.string.isRequired,
        config: PropTypes.shape({
            url: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
        }),
    }).isRequired,
};

export default Share;
